module.exports = __webpack_public_path__ + "img/InterfaceIcon.7e6c1248.png";